<template>
    <div id="standard" style="width:100%;height: 100%;padding: 20px;background: white;box-sizing:border-box"
        v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div style="width: 100%;">
            <el-row style="margin-bottom: 20px;">
                <el-col :span="6"><span style="font-weight: bold; font-size: larger;">合规审查</span></el-col>
                <el-col :span="12" style="text-align: center;">
                    <el-radio-group v-model="category" @change="handleChangeStatus">
                        <el-radio-button label="TODAY">今日会议</el-radio-button>
                        <el-radio-button label="ALL">全部会议</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
        </div>

        <div v-if="category=='TODAY'">
            <div style="font-size: 14px; ">
                今日会议:<el-tag type="info" size="mini" style="margin-left: 5px;">{{tableData.length}}</el-tag>
            </div>
            <el-row>
                <el-col :span="5" v-for="(item, index) in tableData" :key="item.meeting_id"
                    :offset="index > 0 && index%4!=0 ? 1 : 0" style="margin-top: 20px;">
                    <el-card :body-style="{ padding: '0px' }" @click.native="handleDetail(item)">
                        <el-image v-if="false" :src="item.url" lazy style="width: 100%; height: 200px;">
                        </el-image>
                        <div style="padding: 14px;">
                            <div class="bottom clearfix">
                                <span class="span">{{item.subject}}</span>
                            </div>
                            <div class="bottom clearfix">
                                <span class="time">{{ getShowTime(item)}}<span style="color:#3b99f7; margin-left:5px">({{ getStatus(item)}})</span></span>
                                <el-button type="text" class="button">发起人: {{item.alias}}</el-button>
                            </div>
                            <div class="bottom clearfix time">
                                营销项目: <el-tag size="mini" v-if="item.project_name">{{item.project_name}}</el-tag>
                            </div>
                            <div class="bottom clearfix time">
                                讲者: <span class="span time" v-for="(speaker, j) in item.speaker_array"
                                    :key="item.key_id">{{speaker.speaker_name}}({{speaker.institution}})</span>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <div v-if="tableData.length==0" style="width: calc(100%);height: calc(100% - 50px) ; margin-top: 100px;">
                <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png"
                    style="margin:0 auto;display: block;" alt="">
            </div>
        </div>
        <div v-if="category=='ALL'">
            <div style="width: 100%;">
                <el-form label-width="120px">
                    <el-row>
                        <el-row style="margin-top: 20px">
                            <el-col :span="12">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">会议名称</span>
                                <el-input type="text" v-model="searchForm.subject" placeholder="请输入会议名称" style="
                                width:  calc(100% - 120px)">
                                </el-input>

                            </el-col>
                            <el-col :span="12" style="text-align: right">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 90px">会议日期</span>
                                <el-date-picker v-model="searchForm.meeting_date" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" style="
                                    width:  calc(100% - 110px)">
                                </el-date-picker>
                            </el-col>

                        </el-row>
                        <el-row style="margin-top: 20px">
                            <el-col :span="12">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">讲者单位</span>
                                <el-input type="text" v-model="searchForm.institution" placeholder="请输入讲者单位" style="
                                width:  calc(100% - 120px)">
                                </el-input>

                            </el-col>
                            <el-col :span="12" style="text-align: right">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 90px">讲者姓名</span>
                                <el-input type="text" v-model="searchForm.speaker_name" placeholder="请输入讲者姓名"
                                    style="width:calc(100% - 110px)">
                                </el-input>

                            </el-col>

                        </el-row>
                        <el-row style="margin-top: 20px">
                            <el-col :span="12">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">营销项目
                                </span>
                                <el-select v-model="searchForm.project_id" placeholder="请选择营销项目"
                                    style="width: calc(100% - 120px)" clearable>
                                    <el-option v-for="item in project_array" :key="item.project_id"
                                        :label="item.project_name" :value="item.project_id">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12" style="text-align: right">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 90px">创建者姓名</span>
                                <el-input type="text" v-model="searchForm.alias" placeholder="请输入创建者姓名"
                                    style="width:calc(100% - 110px)">
                                </el-input>

                            </el-col>
                        </el-row>
                    </el-row>

                </el-form>
            </div>
            <el-row style="margin-top:21px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
            </el-row>

            <div style="width: 100%;margin-top:10px;">
                <!-- <el-row style="margin-top:20px;">
                    <el-button type="success" size="small" icon="el-icon-plus" @click.stop="handleAddClick">添加讲者
                    </el-button>
                </el-row> -->
                <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="tableData" border
                    style="width: 100%;margin-top: 20px" stripe>
                    <el-table-column align="center" type="index" label="序号" width="60px">
                    </el-table-column>
                    <el-table-column prop="project_name" label="营销项目" width="200">
                    </el-table-column>
                    <el-table-column prop="subject" label="会议名称" width="250">
                    </el-table-column>
                    <el-table-column width="250" label="日期时间">
                        <template slot-scope="scope">
                            {{ getShowTime(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="180" label="讲者">
                        <template slot-scope="scope">
                            <el-tag effect="dark" type="warning" style="margin-right: 5px;margin-bottom: 2px;margin-top: 2px;"
                                v-for="item in scope.row.speaker_array" :key="item.key_id" v-if="item.speaker_id">
                                {{ item.speaker_name }} ({{ item.institution }})
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="alias" label="创建者" width="150">
                    </el-table-column>
                    <el-table-column width="140" prop="status" label="状态">
                        <template slot-scope="scope">
                            <el-tag type="info" effect="plain">
                                {{ getStatus(scope.row) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label-class-name="conference_table_cell" fixed="right" label="操作" width="80"
                        style="color: #3b99f7">
                        <template slot-scope="scope">
                            <el-button type="warning" size="small" @click="handleDetail(scope.row)">详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row style="margin-bottom: 20px">
                    <el-col>
                        <pagination :page="page" @changePage="changePageClick"></pagination>
                    </el-col>
                </el-row>
            </div>
        </div>

    </div>

</template>

<script>
    import http from '../../APIService/http'
    import pagination from "../../components/pagination";
    import { MessageBox, Message } from 'element-ui'
    import moment from 'moment'
    export default {
        name: "speaker",
        data() {
            return {
                loading: false,
                loadingText: "",
                tableData: [],
                page: this.GLOBAL.page_compliance,
                project_array: [],
                product_array: [],
                category: "TODAY",
                searchForm: {
                    project_id: "",
                    product_id: "",
                    subject: "",
                    meeting_date: "",
                    institution: "",
                    speaker_name: "",
                    alias:"",
                    status: "ACTIVE"
                },
            }
        },
        components: {
            pagination
            // Upload
        },
        created() {
            this.getProject();
            this.getProductArray();
            this.init();
        },
        mounted() {
            // document.getElementById('main').scrollTo(0, 0)
        },
        updated() {
        },
        methods: {
            fomartHM(dt) {
                return moment(dt).format("HH:mm")
            },
            getShowTime(row) {
                return moment(row.start_time).format("YYYY-MM-DD HH:mm") + "-" + moment(row.end_time).format("HH:mm");
            },
            getStatus(row) {
                if (row.tx_meeting_status == "INIT") {
                    return "未开始"
                } else if (row.tx_meeting_status == "STARTED") {
                    return "进行中"
                } else if (row.tx_meeting_status == "ENDED") {
                    return "已结束"
                }
                return "未预约";
            },
            async init() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        category: this.category,
                        searchObj: this.searchForm
                    }
                    await http.post('/echo/online/web/meeting/getMeetingList', data).then(res => {
                        loading.close()
                        debugger;
                        if (res.success === true) {
                            // console.log(res)
                            this.page.total = parseInt(res.data.arrayCount)
                            if (this.category == "TODAY") {
                                this.resetData(res.data.array);
                            } else {
                                this.tableData = res.data.array;
                            }
                        }
                    })
                } catch (e) {
                    loading.close();
                    Message({
                        type: "error",
                        message: JSON.stringify(e),
                    });
                } finally {
                    loading.close();
                }
            },
            async resetData(array) {

                for (let i = 0; i < array.length; i++) {
                    const item = array[i];
                    item.url = await this.getImgUrl(item.cover_photo);
                }
                this.tableData = array;
            },
            async getProject() {
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id
                    }
                    await http.post('/crm/project/getProjectByTenantId', data).then(res => {
                        if (res.success === true) {
                            this.project_array = res.data;
                        }
                    })
                } catch (e) {

                }
            },
            async getProductArray() {
                try {
                    let data = this.$store.getters.getDataInfo;
                    data.tenant_id = this.$store.getters.getUser.tenant_id;

                    //this.loading = false
                    await http.post("/crm/product/getProductByTenantId", data).then((res) => {
                        console.log(res, 5555);
                        debugger;
                        this.product_array = res.data;
                    });
                } catch (e) { }
            },
            handleChangeStatus(e) {
                this.tableData = []
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init();
            },
            handleQueryClick() {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init()
            },
            handleResetClick() {
                this.searchForm.speaker_name = "";
                this.searchForm.institution = "";
                this.searchForm.project_id = "";
                this.searchForm.product_id = "";
                this.searchForm.meeting_date = "";
                this.searchForm.alias = "";
                this.searchForm.status = "ACTIVE";
                this.init()
            },
            async handleDetail(row) {
                debugger;
                this.$router.push({
                    name: 'echoComplianceDetail',
                    params: row,
                })
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },

            async getImgUrl(file_id) {
                try {
                    // this.loading = true;
                    let url = "";
                    console.log("----------getImgUrl:" + file_id);
                    let Body = new FormData();
                    Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
                    Body.append("file_ids", file_id);
                    Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
                    Body.append("reference_obj", "CLIENT");
                    Body.append("reference_id", "com.saasyun.android");

                    var config = {
                        headers: { "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY" },
                    }; //添加请求头
                    let data = {
                        credential: "58f09f86-694c-472d-bb63-64f9be093fd2",
                        photo_ids: file_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        reference_obj: "CLIENT",
                        reference_id: "com.saasyun.android",
                        headersContentType: "multipart/form-data",
                    };
                    debugger;
                    let res = await http
                        .post("/photos/downloadphotos", data) //
                        .then((response) => {
                            if (response.success) {
                                url = response.data[0].url;
                            }
                        });

                    this.loading = false;
                    return url;
                } catch (err) {
                    this.loading = false;
                }
            },
        },
        beforeRouteLeave(to, from, next) {

            // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            if (to.name === 'echoComplianceDetail' && to.params.type != 'new') {
                let condition = JSON.stringify(this.searchForm)
                localStorage.setItem('condition', condition)
            } else {
                localStorage.removeItem('condition')
            }
            if (to.name !== 'echoComplianceDetail') {
                this.GLOBAL.page_compliance = {
                    current: 1,
                    size: 5,
                    total: 0
                }
            }
            next()
        }
    }
</script>

<style>
    .el-card__body .span {
        font-size: 15px;
        line-height: 20px;
    }

    .el-card__body .time {
        font-size: 13px;
        color: #999;
    }

    .el-card__body .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .el-card__body .button {
        padding: 0;
        float: right;
    }

    .el-card__body .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>

<style scoped>
    #standard>>>.el-dialog__header {
        border-bottom: 2px dashed #eee;
        padding: 20px 0 10px;
        margin: 0 20px;
    }

    #standard>>>.el-dialog__body {
        padding-top: 20px;
    }

    #standard>>>.el-form-item__label {
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }

    #standard>>>.standard_star label:after {
        content: "*";
        color: #f56c6c;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/echo/compliance.vue